import $ from 'jquery';
import PaymentCalculatorForm from './payment-calculator';

//  Finance/Lease Toggling on Small Calc Form

let financeInfoBtn = $('#show-finance-info');
let leaseInfoBtn = $('#show-lease-info');

let financeInfo = $('.finance-info');
let leaseInfo = $('.lease-info');

function handleInfoShow(div) {
  $('.calculator-info').removeClass('is-active');
  div.addClass('is-active');
}

financeInfoBtn.on('click', function () {
  handleInfoShow(financeInfo);
});

leaseInfoBtn.on('click', function () {
  handleInfoShow(leaseInfo);
});

// Frequency Toggle Styling

$('.payment-frequency-button').on('change', function () {
  $('.payment-frequency-button').removeClass('is-active');
  $('.frequency-btn-label').removeClass('is-active');

  $(this).addClass('is-active');
  $(this).siblings('.frequency-btn-label').addClass('is-active');
});

// VDP Calc Form
let paymentCalculatorForm = new PaymentCalculatorForm('js-calc-small-form');

$('.print-elements').on('click', function () {
  paymentCalculatorForm.printAll(['finance']);
});
